module.exports = __webpack_public_path__ + "static/img/icon04.9beaa37c.svg";